import {Scene} from 'scene';
import {Animation} from 'animation';

export default class MainScene extends Scene
{
    constructor()
    {
        super();

        let self = this;

        let createButton = function(x, y, textureFolder)
        {
            let textureUp = PIXI.utils.TextureCache[textureFolder + "_of.png"];
            let textureOver = PIXI.utils.TextureCache[textureFolder + "_cursor.png"];
            let textureDown = PIXI.utils.TextureCache[textureFolder + "_on.png"];

            let button = new PIXI.Sprite(textureUp);
            button.position.set(x, y);
            button.visible = true;
            button.interactive = true;
            button.buttonMode  = true;
            button.on('pointerdown',function()      {button.texture = textureDown;});
            button.on('pointerup',function()        {button.texture = textureUp;});
            button.on('pointerover',function()      {button.texture = textureOver;});
            button.on('pointerout',function()       {button.texture = textureUp;});
            self.addChild(button);

            let buttonStruct = {button: button, texUp: textureUp, texOver: textureOver, texDown: textureDown};

            return buttonStruct;
        };

        this.background = new PIXI.Sprite(PIXI.utils.TextureCache["res/back.jpg"]);
        this.addChild(this.background);

        this.rotate_angle = 0.0;
        this.rul = new PIXI.Sprite(PIXI.utils.TextureCache["res/roulette/rul.png"]);
        this.rul.anchor.set(0.5, 0.5);
        this.rul.position.set(405+198, 511+198);
        this.addChild(this.rul);

        this.rul_blink = new PIXI.Sprite(PIXI.utils.TextureCache["res/roulette/rul_blink.png"]);
        this.rul_blink.position.set(405, 511);
        this.addChild(this.rul_blink);

        this.ball_shadow = new PIXI.Sprite(PIXI.utils.TextureCache["res/roulette/ball_shadow.png"]);
        this.ball_shadow.anchor.set(0.5, 0.5);
        this.addChild(this.ball_shadow);

        this.ball = new PIXI.Sprite(PIXI.utils.TextureCache["res/roulette/ball.png"]);
        this.ball.anchor.set(0.5, 0.5);
        this.addChild(this.ball);

        this.rul_00_shadow = new PIXI.Sprite(PIXI.utils.TextureCache["res/roulette/rul_00_shadow.png"]);
        this.rul_00_shadow.anchor.set(0.5, 0.5);
        this.rul_00_shadow.position.set(405+198-8, 511+198+8);
        this.addChild(this.rul_00_shadow);

        this.rul_00 = new PIXI.Sprite(PIXI.utils.TextureCache["res/roulette/rul_00.png"]);
        this.rul_00.anchor.set(0.5, 0.5);
        this.rul_00.position.set(405+198, 511+198);
        this.addChild(this.rul_00);

        this.rul_00_blink = new PIXI.Sprite(PIXI.utils.TextureCache["res/roulette/rul_00_blink.png"]);
        this.rul_00_blink.position.set(405+176, 511+176);
        this.addChild(this.rul_00_blink);

        this.balance_tab = new PIXI.Sprite(PIXI.utils.TextureCache["res/buttons/balance_tab.png"]);
        this.balance_tab.position.set(1581, 234);
        this.addChild(this.balance_tab);

        this.button_reload = createButton(1581+203, 234+20, "res/buttons/reload");
        this.button_reload.button.on('pointerup', function()
        {
            self.rotate();
        });

        this.button_clear = createButton(1496, 931, "res/buttons/fiski_away");
        this.button_clear.button.on('pointerup', function()
        {
            self.clear();
            self.font_total_bet.text = "Общая ставка: " + self.total_bet.toString();
        });

        this.button_add_credits = createButton(1204, 234, "res/buttons/input_balance");
        this.button_take_money = createButton(1397, 234, "res/buttons/take_money");

        this.chip_choose = Animation.byFrameName("res/fishka_chosen/fishka_chosen_%03d.png", 20);
        this.chip_choose.anchor.set(0.5, 0.5);
        this.chip_choose.animationSpeed = 0.5;
        this.chip_choose.loop = true;
        this.chip_choose.visible = false;
        this.addChild(this.chip_choose);

        /*window.addEventListener('pointermove', onPointerMove);
        function onPointerMove(event)
        {
            console.log("onPointerMove");

            console.log("event.x=" + event.x);
            console.log("event.width=" + window.innerWidth);
            console.log("event.y=" + event.y);
            console.log("event.height=" + window.innerHeight);
        }*/


        this.chip_selected = -1;

        this.chips = [];
        var chip_names = ["1", "5", "10", "25", "50", "100", "500", "1000"];
        for (let i=0; i<8; i++)
        {
            var chip = new PIXI.Sprite(PIXI.utils.TextureCache["res/fishki/" + chip_names[i] + ".png"]);
            chip.anchor.set(0.5, 0.5);
            chip.position.set(491+96*(i%4)+46, 212+87*self.div(i, 4)+46);
            chip.interactive = true;
            chip.buttonMode  = true;
            chip.on('pointerdown', function()
            {
                self.onButtonDown(i);
            });
            chip.on('pointerup', function()
            {
                self.onButtonUp(i);
            });
            chip.on('pointerover', function()
            {
                self.onButtonOver(i);
            });
            chip.on('pointerout', function()
            {
                self.onButtonOut(i);
            });

            this.addChild(chip);
            this.chips.push(chip);
        }

        this.chips_top = [];
        for (let i=0; i<8; i++)
        {
            var chip = new PIXI.Sprite(PIXI.utils.TextureCache["res/fishki/" + chip_names[i] + ".png"]);
            chip.scale.set(0.55);
            chip.position.set(491+96*(i%4)+46, 212+87*self.div(i, 4)+46);
            chip.visible = false;

            this.addChild(chip);
            this.chips_top.push(chip);
        }

        // кнопки на ставочном поле
        this.bet_buttons = [];
        // zero
        {
            var bet = new PIXI.Sprite(PIXI.utils.TextureCache["res/bets/zero.png"]);
            bet.position.set(940, 646);
            bet.interactive = true;
            bet.buttonMode  = true;
            bet.on('pointerdown', function()
            {
                self.onBetButtonDown(0);
            });

            this.addChild(bet);
            this.bet_buttons.push(bet);
        }
        // numbers
        for (let x=0; x<12; x++)
        for (let y=0; y<3; y++)
        {
            var bet = new PIXI.Sprite(PIXI.utils.TextureCache["res/bets/number.png"]);
            bet.position.set(1050+52*x, 608+70*2-70*y);
            bet.interactive = true;
            bet.buttonMode  = true;
            bet.on('pointerdown', function()
            {
                self.onBetButtonDown(x*3+y+1);
            });

            this.addChild(bet);
            this.bet_buttons.push(bet);
        }
        // dozen
        for (let x=0; x<3; x++)
        {
            var bet = new PIXI.Sprite(PIXI.utils.TextureCache["res/bets/dozen.png"]);
            bet.position.set(1050+208*x, 557);
            bet.interactive = true;
            bet.buttonMode  = true;
            bet.on('pointerdown', function()
            {
                self.onBetButtonDown(x+37);
            });

            this.addChild(bet);
            this.bet_buttons.push(bet);
        }
        // row
        for (let y=0; y<3; y++)
        {
            var bet = new PIXI.Sprite(PIXI.utils.TextureCache["res/bets/row.png"]);
            bet.position.set(1674, 608+70*y);
            bet.interactive = true;
            bet.buttonMode  = true;
            bet.on('pointerdown', function()
            {
                self.onBetButtonDown(y+40);
            });

            this.addChild(bet);
            this.bet_buttons.push(bet);
        }
        // half
        for (let x=0; x<2; x++)
        {
            var bet = new PIXI.Sprite(PIXI.utils.TextureCache["res/bets/half.png"]);
            bet.position.set(1050+x*312, 818);
            bet.interactive = true;
            bet.buttonMode  = true;
            bet.on('pointerdown', function()
            {
                self.onBetButtonDown(x+43);
            });

            this.addChild(bet);
            this.bet_buttons.push(bet);
        }
        // color
        for (let x=0; x<4; x++)
        {
            var bet = new PIXI.Sprite(PIXI.utils.TextureCache["res/bets/color.png"]);
            bet.position.set(1050+x*156, 869);
            bet.interactive = true;
            bet.buttonMode  = true;
            bet.on('pointerdown', function()
            {
                self.onBetButtonDown(x+45);
            });

            this.addChild(bet);
            this.bet_buttons.push(bet);
        }

        this.bets_array_num = []; // массив с числами на которые была ставка
        this.bets_array_val = []; // массив с суммами ставок
        this.wins_array = [];
        for (let i=0; i<49; i++)
            this.wins_array.push(0);

        // LEFT PART
        this.best_players = new PIXI.Sprite(PIXI.utils.TextureCache["res/left_part/best_players.png"]);
        this.best_players.position.set(0, 9);
        this.addChild(this.best_players);

        this.silver = new PIXI.Sprite(PIXI.utils.TextureCache["res/left_part/silver.png"]);
        this.silver.position.set(30, 210);
        this.addChild(this.silver);

        this.bronze = new PIXI.Sprite(PIXI.utils.TextureCache["res/left_part/bronze.png"]);
        this.bronze.position.set(28, 266);
        this.addChild(this.bronze);

        this.hot_dig = new PIXI.Sprite(PIXI.utils.TextureCache["res/left_part/hot_dig.png"]);
        this.hot_dig.position.set(28, 340);
        this.addChild(this.hot_dig);

        this.cold_dig = new PIXI.Sprite(PIXI.utils.TextureCache["res/left_part/cold_dig.png"]);
        this.cold_dig.position.set(12, 498);
        this.addChild(this.cold_dig);

        this.razd_y = [200, 261, 322, 480, 650];
        for (let i=0; i<5; i++)
        {
            var razd = new PIXI.Sprite(PIXI.utils.TextureCache["res/left_part/razdelitel.png"]);
            razd.position.set(0, this.razd_y[i]);
            this.addChild(razd);
        }

        this.coef = new PIXI.Sprite(PIXI.utils.TextureCache["res/left_part/coefficient.png"]);
        this.coef.position.set(26, 676);
        this.addChild(this.coef);

        this.font_credits = new PIXI.extras.BitmapText("", {font: "font_credits", align: "right"});
        this.font_credits.position.set(1581+179, 234+35);
        this.font_credits.anchor.set(1.0, 0);
        this.addChild(this.font_credits);

        // параметры вращения рулетки
        this.roul_max_time = 0.0;
        this.roul_max_path = 0;
        this.roul_angle = 0.0;
        this.last_roul_angle = 0.0;
        this.roul_accel = 0.0;
        this.roul_start_speed = 0.0;
        this.roul_time = 0.0;
        this.roul_speed = 0.0;
        this.win_sector = 0; // сектор, который должен выпасть
        // параметры шарика
        this.ball_max_time = 0.0;
        this.ball_max_path = 0;
        this.ball_accel = 0.0;
        this.ball_start_speed = 0.0;
        this.ball_time = 0.0;
        this.ball_angle = 0;
        this.last_ball_angle = 0.0;
        this.ball_radius = 140;

        this.credits = 100000;
        this.total_bet = 0;
        this.cur_win = 0;

        this.font_total_bet = new PIXI.Text('Общая ставка: 0',{fontFamily : 'Arial', fontSize: 18, fill : 0xffff00, align : 'left'});
        this.font_total_bet.position.set(1060, 940);
        this.font_total_bet.anchor.set(0.0, 0.0);
        this.addChild(this.font_total_bet);

        this.font_total_bet.text = "Общая ставка: " + this.total_bet.toString();

        PIXI.ticker.shared.add(this.update, this);

        this.cur_state = "STAY";

        this.setCredits(this.credits);
    };

    onBetButtonDown(i)
    {
        var self = this;

        if (this.chip_selected>=0 && this.chip_selected<=7)
        {
            // здесь нужна проверка, что клик был в нужном секторе
            if (i==0)
            {
                self.addBet(i, 978, 689);
            }
            else if (i>=1 && i<=36)
            {
                let x = self.div(i-1, 3);
                let y = (i-1)%3;
                self.addBet(i, 1047+52*x, 757-70*y);
            }
            else if (i>=37 && i<=39) // dozen
            {
                let x = i-37;
                self.addBet(i, 1126+208*x, 557);
            }
            else if (i>=40 && i<=42) // row
            {
                let y = i-40;
                self.addBet(i, 1694, 618+y*70);
            }
            else if (i>=43 && i<=44) // half
            {
                let x = i-43;
                self.addBet(i, 1176+x*312, 818);
            }
            else if (i>=45 && i<=48) // color
            {
                let x = i-45;
                self.addBet(i, 1098+x*156, 869);
            }
        }
    }

    onButtonDown(i)
    {
        var self = this;
    }

    onButtonUp(i)
    {
        var self = this;

        this.chip_choose.position.set(491+96*(i%4)-20+70, 212+87*self.div(i, 4)-25+70);
        this.chip_choose.visible = true;
        this.chip_choose.gotoAndPlay(0);

        this.chip_selected = i;
    }

    onButtonOver(i)
    {
        var self = this;
    }

    onButtonOut(i)
    {
        var self = this;
    }

    addBet(i, x, y)
    {
        var chip_value = [1, 5, 10, 25, 50, 100, 500, 1000];

        this.chips_top[this.chip_selected].position.set(x, y);
        this.chips_top[this.chip_selected].visible = true;
        this.total_bet += chip_value[this.chip_selected];
        this.bets_array_num.push(i);
        this.bets_array_val.push(chip_value[this.chip_selected]);
        this.font_total_bet.text = "Общая ставка: " + this.total_bet.toString();

        this.chip_selected = -1;
        this.chip_choose.visible = false;
    }

    div(val, by)
    {
        return (val - val % by) / by;
    }

    terminate()
    {
        this.removeChildren();
        this.destroy();
    }

    setCredits(credits)
    {
        window.parent.postMessage({isWbgMsg:true, name:'creditsChanged', credits:credits}, '*');
        this.font_credits.text = credits;
    }


    clear()
    {
        var self = this;

        if (this.cur_state=="STAY" || this.cur_state=="SHOW_WIN")
        {
            this.bets_array_num = [];
            this.bets_array_val = [];
            this.chip_selected = -1;
            this.total_bet = 0;
            this.chip_choose.visible = false;

            for (let i=0; i<this.chips_top.length; i++)
            {
                this.chips_top[i].visible = false;
            }
        }
    }

    rotate()
    {
        if (this.cur_state=="STAY")
        {
            if (this.total_bet>0 && this.total_bet<=this.credits)
            {
                this.credits-=this.total_bet;
                this.setCredits(this.credits);
                this.chip_choose.visible = false;
                this.cur_state = "START";
            }
        }
    }

    update(dt)
    {
        var self = this;

        switch(this.cur_state)
        {
            case "STAY":
            {

            }
            break;

            case "START":
            {
                // матчасть
                // v=S/t, где v-скорость, S-пройденный путь, t-время
                // v1-конечная скорость, равна 0
                // v0-начальная скорость
                // v0=m_angle/m_max_rulette_time
                // вычисляем ускорение по формуле acc=v1/t-v0/t
                // acc=-m_angle/m_max_rulette_time/m_max_rulette_time
                // v0=-acc*t

                this.win_sector = parseInt(Math.random()*36);
                console.log("win_sector=" + this.win_sector);

                for (let i=0; i<49; i++)
                    this.wins_array[i] = 0;
                this.cur_win = 0;
                this.roul_max_time = 12.0; // время вращения
                this.roul_max_path=5*360.0 + Math.random()*360; // число оборотов рулетки умноженное на 360 + случайная величина
                this.roul_accel=-this.roul_max_path/(this.roul_max_time*this.roul_max_time);
                this.roul_start_speed=-this.roul_accel*this.roul_max_time;
                this.roul_time=0.0; // текущее время вращения колеса рулетки в сек
                this.ball_max_time = 10.0; // время вращения и путь шарика не имеют большого значения, они отвечают только за конечную скорость
                this.ball_max_path=5*360.0;
                this.ball_accel=-this.ball_max_path/(this.ball_max_time*this.ball_max_time);
                this.ball_start_speed=-this.ball_accel*this.ball_max_time;
                this.ball_time=0.0; // текущее время вращения колеса рулетки в сек
                this.last_ball_angle = Math.random()*360;
                this.ball_radius = 240;
                this.cur_state = "ROTATE";
            }
            //break;

            case "ROTATE":
            {
                this.roul_speed = this.roul_start_speed+this.roul_accel*this.roul_time;
                this.roul_angle=this.last_roul_angle + this.roul_max_path + this.roul_speed*this.roul_speed/this.roul_accel;
                this.roul_time+=dt/100.0;

                this.ball_speed = this.ball_start_speed+this.ball_accel*this.ball_time;
                this.ball_angle = -(this.last_ball_angle + this.ball_max_path + this.ball_speed*this.ball_speed/this.ball_accel);
                this.ball_time+=dt/100.0;
                if (this.ball_radius>220)
                    this.ball_radius-=dt/20.0;
                else if (this.ball_angle%45<-1 && this.ball_angle%45>-3)
                    this.cur_state = "BRAKE";
            }
            break;

            case "BRAKE":
            {
                this.roul_speed = this.roul_start_speed+this.roul_accel*this.roul_time;
                this.roul_angle=this.last_roul_angle + this.roul_max_path + this.roul_speed*this.roul_speed/this.roul_accel; // положительная величина
                this.roul_time+=dt/100.0;

                this.ball_speed = this.ball_start_speed+this.ball_accel*this.ball_time;
                this.ball_angle = -(this.last_ball_angle + this.ball_max_path + this.ball_speed*this.ball_speed/this.ball_accel); // отрицательная величина
                this.ball_time+=dt/100.0;
                if (this.ball_radius-dt*3.0>140)
                    this.ball_radius-=dt*3.0;
                else
                {
                    this.ball_radius = 140.0;
                    if (this.roul_speed<=100)
                    {
                        // нужно найти текущий угол сектора, который должен выпасть
                        this.roul_angle_abs = this.roul_angle;
                        while(this.roul_angle_abs>=360)
                        {
                            this.roul_angle_abs-=360;
                        }
                        // если угол рулетки равен 3*9.73, то текущий сектор 33
                        //var rulette_digits=[0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26];
                        var rulette_digits=[0, 26, 3, 35, 12, 28, 7, 29, 18, 22, 9, 31, 14, 20, 1, 33, 16, 24, 5, 10, 23, 8, 30, 11, 36, 13, 27, 6, 34, 17, 25, 2, 21, 4, 19, 15, 32];
                        for (let i=0; i<37; i++)
                        {
                            if (rulette_digits[i] == this.win_sector)
                                this.sector_angle = i * (360/37);
                        }

                        this.sector_angle_abs = this.sector_angle - this.roul_angle_abs;

                        while(this.sector_angle_abs<0)
                        {
                            this.sector_angle_abs+=360;
                        }

                        this.ball_angle_abs = -this.ball_angle;
                        while(this.ball_angle_abs>=360)
                        {
                            this.ball_angle_abs-=360;
                        }

                        //console.log("sector_angle=" + this.sector_angle);
                        //console.log("ball_angle=" + this.ball_angle_abs);

                        if (this.sector_angle_abs-this.ball_angle_abs>-2.8 && this.sector_angle_abs-this.ball_angle_abs<6.8)
                        {
                            this.ball_angle = -(this.sector_angle - this.roul_angle);
                            this.cur_state = "BALL_STOP";
                        }
                    }
                }
            }
            break;

            case "BALL_STOP":
            {
                this.roul_speed = this.roul_start_speed+this.roul_accel*this.roul_time;
                this.roul_angle=this.last_roul_angle + this.roul_max_path + this.roul_speed*this.roul_speed/this.roul_accel; // положительная величина
                this.roul_time+=dt/100.0;

                this.ball_angle = -(this.sector_angle - this.roul_angle);

                if (this.roul_speed<0)
                {
                    this.roul_speed=0;
                    this.last_roul_angle = this.roul_angle;
                    while(this.last_roul_angle>=360)
                    {
                        this.last_roul_angle-=360;
                    }
                    console.log("roul_angle=" + (360 - this.last_roul_angle));
                    this.cur_state = "STOP";
                }
            }
            break;

            case "STOP":
            {
                this.cur_state = "SHOW_WIN";
            }
            break;

            case "SHOW_WIN":
            {
                // заполняем массив выигрышей wins_array
                for (let i=0; i<37; i++)
                {
                    if (i == this.win_sector)
                        this.wins_array[i] = 36;
                }
                for (let i=37; i<40; i++) // dozen
                {
                    let k=i-37;
                    if (this.win_sector>=k*12+1 && this.win_sector<(k+1)*12+1)
                    {
                        this.wins_array[i] = 3;
                    }
                }
                for (let i=40; i<43; i++) // row
                {
                    let k=i-40;
                    if (this.win_sector%3==3-k)
                    {
                        this.wins_array[i] = 3;
                    }
                }
                for (let i=43; i<45; i++) // half
                {
                    let k=i-43;
                    if (this.win_sector>=16*k+1 && this.win_sector<16*(k+1)+1)
                    {
                        this.wins_array[i] = 2;
                    }
                }
                // color
                {
                    let red = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
                    let black = [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];
                    for (let k=0; k<18; k++)
                    {
                        if (black[k]==this.win_sector)
                            this.wins_array[45] = 2;
                        else if (red[k]==this.win_sector)
                            this.wins_array[46] = 2;
                    }
                }
                // even/odd
                {
                    if (this.win_sector>0)
                    {
                        if (this.win_sector % 2 ==1)
                        {
                            // нечет odd
                            this.wins_array[48] = 2;
                        }
                        else
                        {
                            // чет even
                            this.wins_array[47] = 2;
                        }
                    }
                }

                // проходим по ставкам, которые сделал игрок
                for (let i=0; i<this.bets_array_num.length; i++)
                {
                    let coef = this.wins_array[this.bets_array_num[i]];
                    let bet = this.bets_array_val[i];
                    this.cur_win+=coef*bet;
                }
                //console.log("cur_win=" + this.cur_win);
                this.font_total_bet.text = "Выигрыш: " + this.cur_win.toString();
                self.setCredits(this.credits+this.cur_win);
                this.cur_win = 0;
                self.clear();
                this.cur_state = "STAY";
            }
            break;
        }

        this.rul.rotation = this.roul_angle*0.0175;
        this.rul_00.rotation = this.roul_angle*0.0175;
        this.rul_00_shadow.rotation = this.roul_angle*0.0175;
        this.ball.position.set(405+198+this.ball_radius*Math.cos(this.ball_angle*0.0175), 511+198+this.ball_radius*Math.sin(this.ball_angle*0.0175));
        this.ball_shadow.position.set(405+198+this.ball_radius*Math.cos(this.ball_angle*0.0175)-3, 511+198+this.ball_radius*Math.sin(this.ball_angle*0.0175)+3);
    }

    showResult(strResult)
    {
        let self = this;

        let win = 0;
        let resultTable = null;
        switch(strResult)
        {
            case "WIN":
                {
                    this.sndWin.play();
                    this.scoreWin++;
                    win = this.totalBet * 2;
                    resultTable = this.resultWin;
                    break;
                }
            case "FORWARD":
                {
                    this.sndForward.play();
                    this.scoreForward++;
                    win = this.totalBet * 0.9;
                    resultTable = this.resultForward;
                    break;
                }
            case "LOSE":
                {
                    this.sndLose.play();
                    this.scoreLose++;
                    resultTable = this.resultLose;
                    break;
                }
            default:
                break;
        }

        this.credits += win;
        this.setCredits(this.credits);

        window.parent.postMessage({isWbgMsg:true, name:'showResult', strResult:strResult, win:win}, '*');
    }
}



// WEBPACK FOOTER //
// ./src/mainscene.es6